import { render } from "./TescoVoucherUkPaymentMethod.vue?vue&type=template&id=43926fb6"
import script from "./TescoVoucherUkPaymentMethod.vue?vue&type=script&lang=js"
export * from "./TescoVoucherUkPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__